import { AGGREGATED_FIELD_STATE } from '../../../../store/products/helpers/aggregatedFieldState';
import { MIXED_STATUS_ID } from '../../ProductStatusSelect';

export const resolveAggregatedStatusValue = (statusField) => {
  if (statusField?.state === AGGREGATED_FIELD_STATE.MULTIPLE) {
    return MIXED_STATUS_ID;
  }
  return String(statusField?.value || 'DRAFT').toUpperCase();
};

export default resolveAggregatedStatusValue;
